export default __webpack_public_path__ + "static/media/lpimage1.e5d52134.jpg";